export default __webpack_public_path__ + "static/media/leaf.83a7e6c2.png";